{
  "PROFILE_SETTINGS": {
    "LINK": "Profilinställningar",
    "TITLE": "Profilinställningar",
    "BTN_TEXT": "Uppdatera profil",
    "DELETE_AVATAR": "Ta bort Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Your password has been changed successfully",
    "AFTER_EMAIL_CHANGED": "Din profil har uppdaterats. Vänligen logga in på nytt eftersom dina inloggningsuppgifter har ändrats",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Bild för e-postsignatur",
        "HINT": "Används i e-postsignaturer. {'{{'}email_signature_picture{'}}'} ersätts med URL:en till den här bilden (inte en img-tagg) — använd den som bildkälla (src i en img-tagg) i din signatur eller inkorgens signatur. Om den inte anges infogas ingenting.",
        "DELETE_SUCCESS": "Bilden för e-postsignaturen har tagits bort",
        "DELETE_FAILED": "Ett fel uppstod när bilden för e-postsignaturen skulle tas bort, försök igen"
      },
      "AVATAR": "Profilbild",
      "ERROR": "Vänligen åtgärda formulärfel",
      "REMOVE_IMAGE": "Radera",
      "UPLOAD_IMAGE": "Ladda upp bild",
      "UPDATE_IMAGE": "Uppdatera bild",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Din e-postadress är din identitet och används för att logga in."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Anpassa utseendet och känslan i din instrumentpanel.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Instrumentpanelens språk",
          "NOTE": "Åsidosätt kontots språk för din egen instrumentpanel. Lämna tomt för att använda kontots standardspråk.",
          "USE_ACCOUNT_DEFAULT": "Använd kontots standard",
          "API_SUCCESS": "Instrumentpanelens språk har uppdaterats"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Meddelandespråk",
          "NOTE": "Välj om originalmeddelanden eller deras översättningar ska visas",
          "ORIGINAL": "Original",
          "TRANSLATED": "Översatt"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Klistra in-beteende",
          "NOTE": "Välj hur inklistrat innehåll ska hanteras när du skriver meddelanden",
          "UPDATE_SUCCESS": "Dina klistra in-inställningar har uppdaterats",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Behåll all formatering",
              "DESCRIPTION": "Behåll all formatering, inklusive tabeller, stilar och andra HTML-element när du klistrar in innehåll."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Endast text med länkar",
              "DESCRIPTION": "Konvertera till oformaterad text men behåll klickbara länkar när du klistrar in innehåll."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Endast oformaterad text",
              "DESCRIPTION": "Ta bort all formatering och konvertera till oformaterad text när du klistrar in innehåll."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Höjd på svarsrutan",
          "NOTE": "Ange minimihöjden för svarsrutan som en procentandel av skärmhöjden. Gäller endast för e-postkonversationer.",
          "UPDATE_SUCCESS": "Din inställning för svarsrutans höjd har uppdaterats",
          "PERCENT_LABEL": "Höjd (% av skärmhöjden)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Standard",
              "DESCRIPTION": "Svarsrutan börjar liten och växer när du skriver."
            },
            "CUSTOM": {
              "HEADING": "Anpassad",
              "DESCRIPTION": "Svarsrutan har alltid minst den valda procentandelen av skärmhöjden."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Navigera automatiskt till nästa konversation",
        "NOTE": "Växla automatiskt till nästa öppna konversation efter att den aktuella har lösts",
        "UPDATE_SUCCESS": "Inställningen för automatisk navigering har uppdaterats"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Skapa en unik meddelandesignatur som visas i slutet av varje e-postmeddelande du skickar. Du kan även inkludera en infogad bild.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Lösenord",
        "NOTE": "Uppdatering av ditt lösenord skulle återställa dina inloggningar på flera enheter.",
        "BTN_TEXT": "Change password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Åtkomsttoken",
        "NOTE": "Denna token kan användas om du bygger en API-baserad integration",
        "COPY": "Kopiera",
        "REGENERATE": "Generera om",
        "REGENERATE_SUCCESS": "Åtkomsttoken har genererats om. Uppdatera alla integrationer som använder den gamla token.",
        "REGENERATE_CONFIRM_TITLE": "Generera om åtkomsttoken?",
        "REGENERATE_CONFIRM_MESSAGE": "Detta gör den aktuella token ogiltig. Alla integrationer som använder den gamla token slutar fungera."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-tillägg",
        "NOTE": "Installera vårt Chrome-tillägg för att få detaljerade aviseringar om inkommande telefonsamtal.",
        "INSTALL_BUTTON": "Installera tillägg",
        "ALREADY_INSTALLED": "Tillägget är installerat"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Inget",
          "MINE": "Assigned",
          "ALL": "Alla",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Inget",
          "ASSIGNED": "Assigned Conversations",
          "ALL_CONVERSATIONS": "All Conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Läs mer"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-postaviseringar",
        "NOTE": "Uppdatera dina e-postaviseringsinställningar här",
        "CONVERSATION_ASSIGNMENT": "Skicka e-postmeddelanden när en konversation är tilldelad till mig",
        "CONVERSATION_CREATION": "Skicka e-postmeddelanden när en ny konversation skapas",
        "CONVERSATION_MENTION": "Skicka e-postaviseringar när du nämns i en konversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Skicka e-postaviseringar när ett nytt meddelande skapas i en tilldelad konversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-post",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Ett nytt meddelande har skapats i en konversation utan tillgänglig agent",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Tillåt push-aviseringar under ett samtal",
        "TEST_PUSH": "Test",
        "TESTING": "Testar...",
        "TEST_PUSH_DESCRIPTION": "Skicka testaviseringar för att verifiera din konfiguration",
        "TEST_NOTIFICATION_ERROR": "Det gick inte att skicka testaviseringen. Försök igen.",
        "TEST_LOCAL_TITLE": "Testavisering (lokal)",
        "TEST_LOCAL_BODY": "Detta är en lokal webbläsaravisering. Om du ser detta fungerar webbläsaraviseringar!"
      },
      "API": {
        "UPDATE_SUCCESS": "Dina aviseringsinställningar har uppdaterats",
        "UPDATE_ERROR": "Ett fel uppstod vid uppdateringen av inställningarna, vänligen försök igen"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push-notiser",
        "NOTE": "Uppdatera dina inställningar för push-notiser här",
        "CONVERSATION_ASSIGNMENT": "Skicka push-notiser när en konversation tilldelas till mig",
        "CONVERSATION_CREATION": "Skicka push-notiser när en ny konversation skapas",
        "CONVERSATION_MENTION": "Skicka push-meddelanden när du nämns i en konversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Skicka push-meddelanden när ett nytt meddelande skapas i en tilldelad konversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Du har aktiverat push-funktionen för denna webbläsare.",
        "REQUEST_PUSH": "Aktivera push-meddelanden",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilbild"
      },
      "NAME": {
        "LABEL": "Ditt fullständiga namn",
        "ERROR": "Vänligen ange ett giltigt fullständigt namn",
        "PLACEHOLDER": "Vänligen ange ditt fullständiga namn"
      },
      "DISPLAY_NAME": {
        "LABEL": "Visningsnamn",
        "ERROR": "Vänligen ange ett giltigt visningsnamn",
        "PLACEHOLDER": "Ange ett visningsnamn, detta visas i konversationer"
      },
      "POSITION": {
        "LABEL": "Befattning",
        "ERROR": "Ange en giltig befattning",
        "PLACEHOLDER": "Ange din befattning"
      },
      "CUSTOM_LINE": {
        "LABEL": "Anpassad rad",
        "ERROR": "Ange en giltig anpassad rad",
        "PLACEHOLDER": "Ange din anpassade rad"
      },
      "AVAILABILITY": {
        "LABEL": "Tillgänglighet",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Upptagen",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format för e-postförhandsvisning i konversationslistan",
        "NOTE": "Välj vad som visas i konversationslistan för konversationer från e-postinkorgar",
        "SUBJECT": "Ämne",
        "SUBJECT_WITH_NOTE": "Ämne och senaste meddelandet om det är en intern anteckning",
        "UPDATE_SUCCESS": "Inställningen för e-postförhandsvisning har uppdaterats"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Inaktivera tangentbordsgenvägar",
        "NOTE": "Stäng av alla tangentbordsgenvägar i hela applikationen",
        "UPDATE_SUCCESS": "Inställningen för tangentbordsgenvägar har uppdaterats"
      },
      "FOLDER_ORDER": {
        "TITLE": "Mappordning",
        "NOTE": "Anpassa i vilken ordning mappar (anpassade vyer) visas i sidopanelen. Dra och släpp för att ändra ordningen.",
        "NO_FOLDERS": "Inga anpassade mappar hittades. Skapa mappar för att organisera dina konversationer."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfiguration av sidopanelen",
        "NOTE": "Anpassa vilka sektioner som visas i konversationernas sidopanel.",
        "SAVE_BUTTON": "Spara konfiguration",
        "UPDATE_SUCCESS": "Sidopanelens konfiguration har uppdaterats",
        "UPDATE_ERROR": "Ett fel uppstod när sidopanelens konfiguration skulle uppdateras, försök igen",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Alla konversationer",
          "ALL_CONVERSATIONS_DESC": "Visa menyalternativet Alla konversationer i sidopanelen",
          "INBOX": "Inkorg",
          "INBOX_DESC": "Visa huvudinkorgen med olästa aviseringar",
          "CONVERSATION_GROUPS": "Omnämningar och obehandlade",
          "CONVERSATION_GROUPS_DESC": "Visa konversationsgrupperna Omnämningar och Obehandlade",
          "FOLDERS": "Mappar",
          "FOLDERS_DESC": "Visa anpassade vyer (mappar) för organiserade konversationer",
          "TEAMS": "Team",
          "TEAMS_DESC": "Visa konversationer filtrerade efter teamtilldelning",
          "CHANNELS": "Inkorgar",
          "CHANNELS_DESC": "Visa konversationer filtrerade efter inkorg",
          "LABELS": "Etiketter",
          "LABELS_DESC": "Visa konversationer filtrerade efter etiketter"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefoninställningar",
        "NOTE": "Ange inloggningsuppgifter för ditt PBX-system.",
        "USERNAME": "Användarnamn",
        "PASSWORD": "Lösenord",
        "SUBMIT": "Spara",
        "USERNAME_INVALID": "Användarnamnet får endast innehålla bokstäver, siffror och . _ - + — inga mellanslag och ingen e-postadress.",
        "API": {
          "USERNAME_INVALID": "Användarnamnet är inte ett giltigt SIP-användarnamn. Använd endast bokstäver, siffror och . _ - + — inga mellanslag och ingen e-postadress.",
          "USERNAME_TAKEN": "Det här användarnamnet används redan av en annan agent på det här kontot."
        }
      },
      "EMAIL": {
        "LABEL": "Din e-postadress",
        "ERROR": "Ange en giltig e-postadress",
        "PLACEHOLDER": "Ange din e-postadress, detta visas i konversationer"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Ange ett lösenord med minst 6 tecken",
        "PLACEHOLDER": "Ange ett nytt lösenord"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Bekräfta nytt lösenord",
        "ERROR": "Bekräfta lösenord måste matcha lösenordet",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Ändra",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Rapportera ett fel",
    "SELECTOR_SUBTITLE": "Välj ett konto från följande lista",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Rapportera ett fel",
    "DESCRIPTION_LABEL": "Beskrivning av problemet",
    "DESCRIPTION_PLACEHOLDER": "Beskriv problemet du stötte på...",
    "SUBMIT": "Skicka rapport",
    "SUBMITTING": "Skickar...",
    "CANCEL": "Avbryt",
    "SUCCESS": "Felrapporten har skickats. Tack!",
    "VALIDATION_ERROR": "Beskriv problemet innan du skickar"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dagars provperiod återstår.",
    "TRAIL_BUTTON": "Köp nu",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "Det verkar som om du inte har bekräftat din e-postadress ännu. Vänligen kolla din inkorg för verifieringsmailet.",
    "RESEND_VERIFICATION_MAIL": "Skicka verifieringsmail igen",
    "EMAIL_VERIFICATION_SENT": "Ett verifieringsmail har skickats. Kolla din inkorg.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiera",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Koden har kopierats till urklipp"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Hämta",
      "UPLOADING": "Laddar upp...",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "RECORDING_UNAVAILABLE": "Den här inspelningen är inte längre tillgänglig.",
      "DELETE_RECORDING": {
        "BUTTON": "Radera samtalsinspelning",
        "TITLE": "Radera samtalsinspelningen?",
        "DESCRIPTION": "Alla inspelningar av det här samtalet raderas permanent från telefonisystemet och kan inte återställas. Transkriptionen och sammanfattningen av samtalet finns kvar.",
        "CONFIRM": "Radera",
        "SUCCESS": "Samtalsinspelningen har raderats",
        "ERROR": "Det gick inte att radera samtalsinspelningen. Försök igen."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Skicka"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Bekräftar...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Lägg till inkorg"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Konversationer",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "All Conversations",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Deltar",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Rapporter",
    "SETTINGS": "Inställningar",
    "CONTACTS": "Kontakter",
    "DATA_ASSISTANT": "Dataassistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Hem",
    "AGENTS": "Agenter",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp-mallar",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Inkorgar",
    "NOTIFICATIONS": "Aviseringar",
    "CANNED_RESPONSES": "Svarsmallar",
    "INTEGRATIONS": "Integrationer",
    "PROFILE_SETTINGS": "Profilinställningar",
    "ACCOUNT_SETTINGS": "Kontoinställningar",
    "APPLICATIONS": "Applikationer",
    "LABELS": "Etiketter",
    "CUSTOM_ATTRIBUTES": "Egna egenskaper",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Konversationer",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampanjer",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenter",
    "REPORTS_LABEL": "Etiketter",
    "REPORTS_INBOX": "Inkorg",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Översikt",
    "WALLBOARD_QUEUES": "Köer",
    "DATA_ASSISTANT_CHAT": "Chatt",
    "DATA_ASSISTANT_REPORTS": "Rapporter",
    "NO_WAITING_CALLERS": "inga uppringare väntar",
    "WAITING_CALLERS": "{count} uppringare väntar",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Ställ in din tillgänglighet",
    "AVAILABILITY_IMPERSONATING": "Låst medan du är inloggad som den här användaren",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Ny konversation",
    "DRAFT": "Utkast",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Hjälpcenter",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Inställningar",
      "DICTIONARY": "Ordlista"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blockerade domäner och kontakter",
    "DESCRIPTION": "Lista över blockerade e-postdomäner för det här kontot.",
    "NO_BLOCKED_DOMAINS": "Inga blockerade domäner hittades.",
    "BLOCKED_CONTACTS_BTN": "Blockerade kontakter"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Chatta med oss"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oj då! Vi kunde inte hitta några konton. Skapa ett nytt konto för att fortsätta.",
    "NEW_ACCOUNT": "Nytt konto",
    "SELECTOR_SUBTITLE": "Skapa ett nytt konto",
    "API": {
      "SUCCESS_MESSAGE": "Kontot har skapats",
      "EXIST_MESSAGE": "Konto finns redan",
      "ERROR_MESSAGE": "Kunde inte ansluta till Woot Server, försök igen senare"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Företagsnamn",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Skicka",
      "CANCEL": "Avbryt"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "AI-hjälp",
      "AI_ASSIST_GRAMMAR": "Rätta grammatik",
      "AI_ASSIST_UNIFY_LANG": "Enhetligt språk i meddelandet"
    }
  }
}
